import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(err) {
  // Axios sets these when the request never reached the server (offline, DNS,
  // CORS block, backend down). In that case there is NO response object.
  const isAxios = err && typeof err === "object" && ("isAxiosError" in err || "response" in err);
  if (isAxios && !err.response) {
    if (err.code === "ECONNABORTED") return "Request timed out. Please check your connection and try again.";
    return "Can't reach the server. Please check your internet connection and try again.";
  }
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
